<template>
    <article>

        <!-- 年卡费用 (未开通包括已过期时显示) -->
        <div class="white_bg marginT8" style="padding-bottom: 12px" v-show="!userInstance || !userInstance.isVipType('datum')">
            <div class="generalPagePaddingH">
                <div class="wFit center paddingT16">
                    <div class="relative">
                        <img class="limit_max_width" src="vip/vip_datum_year_price.png" width="339" height="auto"/>
                        <div class="alignC red" style="font-size: 20px; position: absolute;
                            top: 35px; width: 100%; left: 0">
                            ￥{{vipPrice}}/年
                        </div>
                        <div class="alignC marginT8 textDelete f16" style="color: #B8C2D6; position: absolute;
                            top: 58px; width: 100%; left: 0">
                            ¥{{originalPrice}}
                        </div>
                    </div>
                    <div class="font13r">
                        <label>
                            <input class="modernCheckbox redCircleTickCheckbox" type="checkbox" :checked="agreeServiceProtocol"
                                @change="changeAgreeServiceProtocol"/>
                            <span style="color: hsla(219, 9%, 39%, 1)">开通即同意</span>
                            <a style="color: hsla(2, 100%, 70%, 1);" :href="externalApp.oldShixun.baseUrl + 'html/txt.html?VIP=VIP'">
                                《师讯VIP会员服务协议》
                            </a>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="white_bg marginT8 paddingH8" style="padding-top: 4px;">
            <article class="article" v-if="details.length">
                <img v-if="details[0].cover" :src="details[0].cover"/>
            </article>
        </div>

        <customerServiceQrDrawer ref="customerServiceQrDrawer" :qrUrl="customerServiceQrDrawer.qrUrl"/>
        <downloadToEmailDrawer ref="downloadToEmailDrawer" @submit="downloadToEmail"/>

    </article>
</template>

<script>
import introductionPart from './introductionPart';

// style
import './indroduction.scss';

// modules
import bannerModule from '@comp/bannerModule';
import customerServiceQrDrawer from '@comp/drawer/customerServiceQrDrawer'
import downloadToEmailDrawer from '@pages/vip/downloadToEmailDrawer';

// data
import externalApp from '@data/externalApp';
import vipTypeEnum2 from '@data/vipTypeEnum2';
let vipType = vipTypeEnum2.DATUM;

export default {
    extends : introductionPart,
    components: { bannerModule, customerServiceQrDrawer, downloadToEmailDrawer },
    props : {
        vipPrice : String,
        originalPrice : String,
        details : Array,
    },
    data() {
        return {
            vipType : vipType,
            externalApp : externalApp
        }
    },
    methods : {

    }
}
</script>

<style lang="scss" scoped>

.red {
    color: #F7504C;
}

.privilegeArea {
    .redReceiveButton {
        position: absolute;
        z-index: 1;
        right: 2px;
        bottom: 12px;
    }
}

.datumList {
    .header {
        position: relative;
        .title {
            padding-left: 8px;
            line-height: 22px;
            &:before {
                display: block;
                content: '';

                width:4px;
                height:14px;
                background:linear-gradient(90deg,rgba(246,108,83,1) 0%,rgba(236,76,72,1) 100%);
                border-radius:2px;

                position: absolute;
                z-index: 1;
                left: 0;
                top: 4px;
            }
        }
    }

    .datumItem {
        padding: 16px 0 12px;
    }
}

</style>
